import { useMemo } from "react";
import SidePanelMenuItem from "./SidePanelMenuItem";
import { IoCloseOutline } from "react-icons/io5";
import Logo from "../Logo/Logo";

// Define the type for menu items
export type MenuItem = {
  description: string;
  href: string;
};

// Define props interface for SidePanel
export interface SidePanelProps {
  menuItems?: MenuItem[];
  onCloseMobile?: () => void;
  isVisible?: boolean;
}

const SidePanel = ({
  menuItems = [],
  onCloseMobile,
  isVisible = true,
}: SidePanelProps) => {
  const currentPath = useMemo(() => window.location.pathname, []);

  return (
    <aside
      id="sidebar"
      className={`sidebar bg-grey-dark gap-10 top-0 z-50 fixed inset-0 w-[300px] ${
        !isVisible ? "sidebar-hidden" : ""
      }`}
    >
      <div className="px-6 py-10 flex justify-between items-center">
        {/* Hide logo on mobile */}
        <Logo showOnlyOnDesktop className="w-20 mx-auto" />
        <button
          onClick={onCloseMobile}
          className="md:hidden text-white p-2 focus:outline-none"
          aria-label="Close menu"
        >
          <IoCloseOutline size={24} />
        </button>
      </div>
      <div className="sidebar__holder">
        <ul className="nav flex-column px-4 flex flex-col gap-2">
          {menuItems.map((item) => (
            <SidePanelMenuItem
              key={item.href}
              {...item}
              isActive={currentPath === item.href}
            />
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default SidePanel;
